import React from 'react'
import { Link } from "react-router-dom";

const SolarWaterPumpSolution = () => {
  return (
    <>
      <div className="site-breadcrumb" style={{ background: 'url(assets/yog/0101.webp)' }}>
        <div className="container">
          <h2 className="breadcrumb-title">Solar Water Pump Solution</h2>
          <ul className="breadcrumb-menu">
            <li><Link to="/">Home</Link></li>
            <li className="active"><b>Solar Water Pump Solution</b></li>
          </ul>
        </div>
      </div>
      <div className="service-single py-120" style={{ marginTop: "-80px" }}>
        <div className="container">
          <div className="service-single-wrap">
            <div className="row">

              <div className="col-xl-4 col-lg-4">
                <div className="service-sidebar">
                  <div className="widget">
                    <h4 className="title">All Services</h4>
                    <div className="category">
                      <Link to="/solar-water-pump-solution"><i className="far fa-angle-double-right" /><b>Solar Water Pump Solution</b></Link>
                      <Link to="/solar-electrical-installation"><i className="far fa-angle-double-right" /><b>Solar & Electrical Installation</b></Link>
                      <Link to="/on-grid-off-grid-solar"><i className="far fa-angle-double-right" /><b>On-Grid & Off-Grid Solar</b></Link>
                      <Link to="/hybrid-solar-power-plant"><i className="far fa-angle-double-right" /><b>Hybrid Solar Power Plant</b></Link>
                      <Link to="/EV-charging-solution"><i className="far fa-angle-double-right" /><b>EV Charging Solution</b></Link>
                      <Link to="/energy-efficient-building"><i className="far fa-angle-double-right" /><b>Energy Efficient Building</b></Link>
                      <Link to="/solar-water-heater-solution"><i className="far fa-angle-double-right" /><b>Solar Water Heater Solution</b></Link>
                    </div>
                  </div>
                  {/* <div className="widget">
                    <h4 className="title">Download</h4>
                    <div className="service-download">
                      <a to="#"><i className="far fa-file-pdf" /> Download Brochure</a>
                      <a to="#"><i className="far fa-file-alt" /> Download Application</a>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="col-xl-8 col-lg-8">
                <div className="service-details">
                  <div className="mb-30">
                    <img src="assets/yog/Solar Water Pump.webp" alt="thumb" />
                  </div>
                  <div className="content">
                    <h3 className="mb-20">Reliable, Cost-Effective & Eco-Friendly Water Pumping</h3>
                    <p className="mb-20" style={{ textAlign: "justify" }}>
                      At Yogesh Solar Energy, we provide advanced Solar Water Pump Solutions designed to meet the irrigation and water supply needs of farmers, industries, and rural households. Our systems use clean solar power to pump water efficiently—reducing electricity costs and eliminating dependency on unreliable grid supply.
                    </p>
                    <h3 className="mb-20">What is a Solar Water Pump?</h3>
                    <p className="mb-20" style={{ textAlign: "justify" }}>
                      A solar water pump is a system powered by solar panels that converts sunlight into electricity to run water pumps. It is an ideal solution for areas with limited or no access to electricity.
                    </p>
                    {/* <div className="row">
                      <div className="col-md-6 mb-20">
                        <img src="assets/img/service/01.jpg" alt />
                      </div>
                      <div className="col-md-6 mb-20">
                        <img src="assets/img/service/02.jpg" alt />
                      </div>
                    </div> */}
                    <div className="my-4">
                      <div className="mb-3">
                      </div>
                      <h3 className="mb-20">Our Solar Pumping Solutions</h3>
                      <p className="mb-20" style={{ textAlign: "justify" }}>
                        We offer a wide range of customized solar pumping systems:
                      </p>
                      <ul className="list">
                        <li><i className="far fa-check-double" /> Submersible Solar Pumps – Ideal for deep bore wells</li>
                        <li><i className="far fa-check-double" /> Surface Solar Pumps – Perfect for rivers, ponds, and shallow wells</li>
                        <li><i className="far fa-check-double" /> DC & AC Solar Pumps – Based on your energy requirements</li>
                        <li><i className="far fa-check-double" /> Drip Irrigation Integration – Efficient water management for farming</li>
                      </ul>
                      <h3 className="mb-20">Key Benefits</h3>
                     
                      <li> 💰 Zero Electricity Cost – Save on monthly bills</li>
                      <li> 🌱 Low Maintenance – Durable and long-lasting systems</li>
                      <li> 🔥 Eco-Friendly – Reduces carbon footprint</li>
                      <li> 🛠️ 24/7 Water Availability – Especially in sunny regions</li>
                      <li> 📈 Government Subsidy Support – Assistance in availing schemes</li>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



    </>
  )
}

export default SolarWaterPumpSolution